type NotificationType = "ACTION_REQUIRED" | "INFORMATIONAL" | "HINT" | "WARNING"
type SelectOption = { name: string; value: string }

export const KEHRBLATT_INBOX_NOTIFICATION_TYPES: NotificationType[] = [
  "ACTION_REQUIRED",
  "WARNING",
  "HINT",
  "INFORMATIONAL",
]

export const KEHRBLATT_INBOX_TODO_TYPE_FILTERS: SelectOption[] = [
  {
    name: "Neue Person zuordnen",
    value: "customer_contact_verification",
  },
  {
    name: "Kontaktdaten prüfen",
    value: "customer_contact_point_review",
  },
  {
    name: "Falschen Ansprechpartner korrigieren",
    value: "wrong_recipient_replacement",
  },
  {
    name: "Unklaren Terminrücklauf klären",
    value: "unclear_appointment_feedback",
  },
  {
    name: "Terminbriefe zustellen",
    value: "letter_delivery_batch",
  },
]
